export default __webpack_public_path__ + "static/media/g24902.6e097715.svg";